import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// Estilos base primero: el CSS de cada componente debe poder sobrescribir .wrap, .sec, .btn-wa, etc.
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CertStrip from './components/CertStrip';
import MiMundo from './components/MiMundo/MiMundo';
import AcercaDe from './components/AcercaDe';
import Testimonios from './components/Testimonios';
import Redes from './components/Redes';
import FAQ from './components/FAQ';
import Contacto from './components/Contacto';
import Tours from './components/Tours';
import EventosPagina from './components/Eventos/EventosPagina';
import EventoPagina from './components/Eventos/EventoPagina';
import EventosInicio from './components/Eventos/EventosInicio';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import useReveal from './hooks/useReveal';
import { scrollToId } from './utils';

// Estilo del globo: 'realista' (satélite nocturno) o 'ilustrado' (acuarela, como el logo).
// Para comparar las dos propuestas en el preview, agrega ?globo=ilustrado a la URL.
const ESTILO_GLOBO = new URLSearchParams(window.location.search).get('globo') === 'ilustrado' ? 'ilustrado' : 'realista';

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    const id = location.pathname === '/' && location.state && location.state.scrollTo;
    if (id) {
      setTimeout(() => {
        scrollToId(id);
        window.history.replaceState({}, document.title, window.location.pathname);
      }, 120);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
}

function Inicio() {
  const mundo = useRef(null);
  const verEnMapa = (lugar) => {
    // en el celular el globo abre el lugar y baja directo a él; en escritorio entra la sección completa y luego se enfoca
    if (mundo.current && mundo.current.verLugarEnGlobo(lugar)) return;
    scrollToId('mundo');
    setTimeout(() => mundo.current && mundo.current.focoLugar(lugar), 600);
  };
  return (
    <>
      <Hero />
      <CertStrip />
      <MiMundo ref={mundo} estilo={ESTILO_GLOBO} />
      <AcercaDe />
      <Testimonios onVerEnMapa={verEnMapa} />
      <Redes />
      <EventosInicio />
      <FAQ />
      <Contacto />
    </>
  );
}

function Layout() {
  useReveal();
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/eventos" element={<EventosPagina />} />
        <Route path="/eventos/:id" element={<EventoPagina />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollManager />
      <Layout />
    </Router>
  );
}
